import { z } from "zod";
export const compilationSongIds = [
    "a-minor-waltz",
    "auld-lang-syne",
    "avocado-street",
    "ballerina",
    "birthday-cake",
    "boardroom-theme",
    "bright-skies",
    "building-blocks",
    "campfire-song",
    "chords-of-harmony",
    "christmas-village",
    "corndogs-in-santa-monica",
    "cute-avalanche",
    "daleys-reel",
    "deck-the-halls",
    "distance",
    "dome-sweet-dome",
    "dulcinea",
    "dutty",
    "esthers-waltz",
    "first-love",
    "fond-memories",
    "fun-activity",
    "get-outside",
    "glen-canyon",
    "good-times",
    "happy-birthday-bossanova",
    "happy-birthday-bouncy",
    "happy-birthday-funk",
    "happy-birthday-jazz-waltz",
    "happy-birthday-mambo",
    "happy-birthday-soul",
    "happy-mistake",
    "homebound",
    "i-have-a-little-dreidel",
    "jack-in-the-box",
    "jingle-bells",
    "joy-to-the-world",
    "longer-distance",
    "morning-mandolin",
    "mosswood",
    "mr-sunny-face",
    "new-year",
    "o-christmas-tree",
    "piano-journey",
    "put-on-your-dancing-pants",
    "roll-and-drop",
    "rolling-heads",
    "ruination",
    "safety-net",
    "silence-for-a-film",
    "smile-quiet-looking-up",
    "southern-california",
    "spring-in-my-step",
    "strong-bones",
    "summer-symphony-ball",
    "sunshine",
    "swoop",
    "take-me-out-to-the-ballgame",
    "the-creek",
    "the-only-girl",
    "ukulele-beach",
    "venice-beach",
    "water-lily",
    "we-wish-you-a-merry-christmas",
    "whispering-stream",
    "wigs",
    "winds-of-spring",
    "wish-youd-come-true",
    "yellow-jello",
];
// If we ever store the themes in a database, we won't be able to strongly type
// the IDs. But for now, we can.
export const compilationSongIdSchema = z.enum(compilationSongIds);
// If we ever store the themes in a database, we won't be able to strongly type
// the IDs. But for now, we can.
const compilationGenreIdSchema = z.union([
    z.literal("pop"),
    z.literal("electronic"),
    z.literal("acoustic"),
]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const compilationGenreSchema = z.object({
    id: compilationGenreIdSchema,
    name: z.string(),
    songs: z.array(compilationSongIdSchema),
});
// If we ever store the themes in a database, we won't be able to strongly type
// the IDs. But for now, we can.
const compilationMoodIdSchema = z.union([
    z.literal("relaxed"),
    z.literal("upbeat"),
]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const compilationMoodSchema = z.object({
    id: compilationMoodIdSchema,
    name: z.string(),
    songs: z.array(compilationSongIdSchema),
});
export const compilationSongSchema = z.object({
    id: compilationSongIdSchema,
    name: z.string(),
    duration: z.number(),
    urls: z.array(z.string()),
});
